import React, { memo, useRef, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Flex, InputGroup, Input, Box } from '@chakra-ui/react';

import DsrManageOrgLogosModule from '../dsr-draft/DsrManageOrgLogosModule';
import '../../layout/components/header/styles/header.scss';
import SaveDraftProspectDsrButton from './draft-prospect-dsr/SaveDraftProspectDsrButton';
import DsrNavigationDrawerMenu from '../../layout/components/sidebar/components/DsrNavigationDrawerMenu';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckTag from '../../global/components/helper-components/components/LaunchdeckTag';
import { DsrPreviewToggleButton } from "../dsr-draft/page-designer/toggle-button/DsrPreviewToggleButton";
import { redirectToNewPage } from '../../global/helpers/global-helpers';
import { formatDisplayLocalDateTime } from '../helpers/timestamp-display-helper';

function DsrLiveEditProspectHeader({
  pDsrId,
  dsrTitle,
  pdsrPagesLocalState,
  updatePdsr,
  userProfile,
  // Redux
	dsrPropertiesRedux,
	prospectorLastSaved,
  isPagePreviewMode,
  setIsPagePreviewMode,
}) {
	const { logoDisplayOption } = dsrPropertiesRedux || {}

	const headerTitleInputRef = useRef(null);

	const [displayedLastSaved, setDisplayedLastSaved] = useState(null);
	const [updateCount, setUpdateCount] = useState(0)
	const [currentDsrTitle, setCurrentDsrTitle] = useState("")
	const [showEditTitleInput, setShowEditTitleInput] = useState(false)
	const [isProcessing, setIsProcessing] = useState(null); 

	const [largeLogoDisplay, setLargeLogoDisplay] = useState(false)


	useEffect(() => {
		if (prospectorLastSaved) {
			setDisplayedLastSaved(prospectorLastSaved); 
			setUpdateCount(prevCount => (prevCount + 1))
		}

	}, [prospectorLastSaved]);

	useEffect(() => {
		if (logoDisplayOption === "large-logos" || logoDisplayOption === "nametag") {
			setLargeLogoDisplay(true)
		} else if (logoDisplayOption === "default") {
			setLargeLogoDisplay(false)
		}
	},[logoDisplayOption]);

	useEffect(() => {
		if (isProcessing) {
			const timer = setTimeout(() => {
        if (pDsrId) redirectToNewPage(`/pdsr/${pDsrId}`); 
				else setIsProcessing(false)
      }, 1500);

      return () => clearTimeout(timer);
		}
	},[isProcessing, pDsrId]);


	// UX listeners
	useEffect(()=> {
		if (dsrTitle) {
			setCurrentDsrTitle(dsrTitle)
		}
	},[dsrTitle])

	useEffect(() => {
		document.addEventListener("keydown", handleHitKey, true);
		document.addEventListener("click", handleClickEditInput, true);
		return () => {
			document.removeEventListener("keydown", handleHitKey, true);
			document.removeEventListener("click", handleClickEditInput, true);
		};
	});

	const handleInputChange = (event) => {
		if (event.target.name === "title") {
			setCurrentDsrTitle(event.target.value)
		}
	}

	const handleHitKey = (event) => {
		if (event.key === "Escape") {
			setShowEditTitleInput(false)
		} else if (event.key === 'Enter') {
			if (event.target.name === "title") {
				clickOutsideAutosave()
			}
		}
	};

	const clickOutsideAutosave = () => {
		setShowEditTitleInput(false)

		if (currentDsrTitle.trim().length > 0) {
			updatePdsr({
				pDsrId,
				dsrTitle: currentDsrTitle,
				sourceEvent: "update-pdsr-title"
			})
		} else (
			setCurrentDsrTitle(dsrTitle ? dsrTitle : "-")
		)
	}

	const handleClickEditInput = (event) => {
		if (headerTitleInputRef.current && !headerTitleInputRef.current.contains(event.target)) {
			clickOutsideAutosave()
		}
	};

	const renderDsrTitle = () => {

		if (showEditTitleInput) {
			return (
				<Flex fontWeight='600' lineHeight='1.875em' ref={headerTitleInputRef} >
					<InputGroup
						size="2em"
						width="100%"
						maxWidth='35%'
						minWidth='25em'
						border='none'
					>
						<Input
							name="title"
							value={currentDsrTitle}
							onChange={handleInputChange}
							onKeyDown={handleHitKey}
							autoFocus={true}
							// onFocus={e => e.currentTarget.select()}
							fontSize='1.25em'
							border='1px solid'
							borderColor='#3295EC'
							borderRadius='0.25em'
							paddingLeft='5px'
							lineHeight='1.875em'
							fontWeight="600"
						/>

					</InputGroup></Flex>
			)

		} else {
			return (
				<Flex fontWeight='600' fontSize='1.25em' lineHeight='1.875em' justify={['center', 'center', 'flex-start', 'flex-start']} pb={['1em', '1em', '0', '0']}>
					<Flex
						cursor={'pointer'}
						onClick={() => setShowEditTitleInput(!showEditTitleInput)}
						border='1px solid'
						borderColor='transparent'
						paddingLeft='5px'
					>
						{dsrTitle}
					</Flex>
				</Flex>
			)
		}
	}

	
		return (
			<>
				<Flex className='dsr-header__section'>
					<Flex className='dsr-header__container' align='center'>
						<Flex justify='flex-start' align='center' pb='0.25em'>
							<DsrNavigationDrawerMenu userProfile={userProfile} darkMode={true} />
							<Box
								className="page-title"
								fontSize='1.25em' fontWeight='600' lineHeight='1.85em' color='white'
								display='inline-block' ml='2em'>
								Manage Prospector
							</Box>
							<Box ml='0.5em'>
								<LaunchdeckTag bg='brandPink.500' color='white' label='Edit mode' />
							</Box>
						</Flex>
						<Flex position='absolute' key={updateCount} visibility={updateCount <= 0 && 'hidden' } className='fade-in' fontSize='0.65em' color='white' fontWeight='500' top='5em' left='9.5em'>
							Autosaved:   {formatDisplayLocalDateTime(displayedLastSaved)}
						</Flex>

						<Flex visibility={isProcessing && 'hidden'} className={isProcessing === false && "fade-in"}>
							<DsrPreviewToggleButton
								offLabelText="Edit"
								onLabelText="Preview"
								isChecked={isPagePreviewMode}
								setIsChecked={setIsPagePreviewMode}
							/>
						</Flex>

						<Flex>
							<Flex gap={6} pr='1em'>
								<Box visibility={isProcessing && 'hidden'} className={isProcessing === false && "fade-in"}>
									<SaveDraftProspectDsrButton
										pDsrId={pDsrId}
										dsrPages={pdsrPagesLocalState}
									/>
								</Box>
								<Box>
									<LaunchdeckButton 
									bg='brandGreen.500' 
									color='white' 
									loadingLogic={isProcessing}
									onClick={() => setIsProcessing(true)} 
									label='Save & close' />
								</Box>
							</Flex>
						</Flex>

					</Flex>
				</Flex>

				<Flex className='dsr-content__dsr-top-banner'>
					<Flex align='center' gap='1em' py={logoDisplayOption==="nametag" && '1em'} minH='4.5em'>
						<DsrManageOrgLogosModule logoDisplayMode={logoDisplayOption==="nametag" ? 'nametag' : 'prospect-dsr'}  isPagePreviewMode={isPagePreviewMode} logoSize={largeLogoDisplay && '3.5em'} />
						{renderDsrTitle()}
					</Flex>

				</Flex>
			</>
		);
};


const mapStateToProps = (state) => ({
  dsrPropertiesRedux: state.draftDsrProperties.properties,
	prospectorLastSaved: state.dsrLastSaved.results,
})

export default memo(withRouter(connect(mapStateToProps, null)(DsrLiveEditProspectHeader)))
